const overviewItems = [
  {
    icon: 'ri-film-line',
    title: '在线观看',
    desc: '说明在线观看入口的浏览方式与常见问题。',
    href: '#features',
  },
  {
    icon: 'ri-gift-line',
    title: '免费观影',
    desc: '整理免费观影相关信息的查看方向。',
    href: '#entrance',
  },
  {
    icon: 'ri-hd-line',
    title: '高清播放',
    desc: '介绍画质选择与网络条件的影响。',
    href: '#guide',
  },
  {
    icon: 'ri-smartphone-line',
    title: '手机版',
    desc: '手机浏览器下的排版与操作说明。',
    href: '#device',
  },
  {
    icon: 'ri-links-line',
    title: '网页入口',
    desc: '入口的收藏与访问建议。',
    href: '#entrance',
  },
  {
    icon: 'ri-global-line',
    title: '网址',
    desc: '关于网址与书签使用的通用说明。',
    href: '#entrance',
  },
];

export default function Overview() {
  return (
    <section id="overview" className="w-full bg-background-50 pb-2 pt-14 md:pt-20">
      <div className="w-full px-4 md:px-8">
        <div className="rounded-2xl bg-background-100/70 border border-background-200/80 p-6 md:p-9">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950">
                一页看懂本站内容分布
              </h2>
              <p className="mt-2.5 text-foreground-700 text-xs md:text-sm leading-relaxed max-w-2xl">
                下面按搜索关键词整理出六个方向，点击任意一项可跳转到对应分区，快速定位你需要的信息。
              </p>
            </div>
            <span className="self-start md:self-auto inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-accent-100 text-accent-900 text-xs font-medium whitespace-nowrap">
              <i className="ri-layout-masonry-line" />
              6 个浏览方向
            </span>
          </div>

          <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {overviewItems.map((item) => (
              <a
                key={item.title}
                href={item.href}
                className="group flex items-start gap-3.5 rounded-lg bg-background-50 border border-background-200/70 p-4 hover:border-secondary-300 transition-colors"
              >
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 text-xl">
                  <i className={item.icon} />
                </span>
                <span className="min-w-0">
                  <span className="flex items-center gap-1.5">
                    <span className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                      {item.title}
                    </span>
                    <i className="ri-arrow-right-up-line text-foreground-400 text-xs group-hover:text-primary-600 transition-colors" />
                  </span>
                  <span className="mt-1 block text-foreground-600 text-xs md:text-sm leading-relaxed">
                    {item.desc}
                  </span>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}